// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1P94j","wrapper":"Item_wrapper__3wgVW","name":"Item_name___AOrB","msg":"Item_msg__1sjcv"};